import { call, put, select } from 'redux-saga/effects';
import { signalingPrivateOpenedWhiteboardsReceived } from 'features/whiteboard/actions';
import { activeWhiteboardsCollectionUpdated } from 'features/content-library/contentLibrarySlice';
import { GridPanelName } from 'features/layout/features/content/types';
import {
  gridPanelAvailableTabChanged,
  gridPanelOpened,
  selectGridPanel,
} from 'features/layout/features/content/contentSlice';
import { openLastActiveWhiteboardSaga } from 'features/content-library/sagas/openLastActiveWhiteboardSaga';
import { selectCanManagePrivateWhiteboards } from 'features/permissions/permissionsSlice';

export function* onPrivateOpenedWhiteboardsReceivedSaga(
  action: ReturnType<typeof signalingPrivateOpenedWhiteboardsReceived>
) {
  const { whiteboards } = action.payload;

  const canManagePrivateWhiteboard: boolean = yield select(selectCanManagePrivateWhiteboards);

  if (!canManagePrivateWhiteboard) {
    return;
  }

  const whiteboardsRecord = whiteboards.reduce(
    (result, whiteboard) => ({
      ...result,
      [whiteboard.id]: whiteboard,
    }),
    {}
  );

  yield put(activeWhiteboardsCollectionUpdated(whiteboardsRecord));

  const currentGridPanel: GridPanelName = yield select(selectGridPanel);

  if (!currentGridPanel || currentGridPanel === 'whiteboard') {
    yield call(openLastActiveWhiteboardSaga);

    if (!currentGridPanel) {
      yield put(gridPanelOpened('whiteboard'));
    }
  }

  if (currentGridPanel && currentGridPanel !== 'whiteboard') {
    yield put(gridPanelAvailableTabChanged({ type: 'whiteboard', active: true }));
  }
}
